export enum ProductStatusEnum {
	NotSupported = 'D', //--product not support
	Supported = 'A',
}
